import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { IconComponent } from '@shared/ui-components/icon/icon.component';
import { MatBadgeModule } from '@angular/material/badge';
import { RouterLink } from '@angular/router';
import { NotificationsDrawerComponent } from './notifications-drawer/notifications-drawer.component';
import { Store } from '@ngrx/store';
import { notificationsSelectors } from '@store/selectors/notifications.selectors';

@Component({
  selector: 'ac-notifications-trigger',
  standalone: true,
  imports: [IconComponent, MatBadgeModule, RouterLink, NotificationsDrawerComponent],
  templateUrl: './notifications-trigger.component.html',
  styleUrls: ['./notifications-trigger.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsTriggerComponent {
  showDrawer = signal(false);

  /** STORE SIGNALS  */
  readonly unreadCountSig = this._store.selectSignal(notificationsSelectors.unreadCounter);

  constructor(private readonly _store: Store<Store>) {}

  onOpen() {
    this.showDrawer.set(true);
  }

  onClose() {
    this.showDrawer.set(false);
  }
}
